/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: web-guard.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/app/middleware/register/web-guard.js
 */

import store from '../../../stores'

export default (to, from, next) => {
    if (to.path && to.path === '/login') {
        store.dispatch('userSession/checkLogin').then(() => {
            if (store.getters['userSession/isLogin']) {
                next(store.getters['userSession/userInfo'].profile.defaultPage);
            }
            else next();
        })
    } else {
        next();
    }
};
